var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _g, _path, _ellipse5, _text, _text2, _ellipse6, _text3, _text4, _g2, _g3, _g4, _g5, _path2, _path3, _text5, _text6, _g6, _g7, _g8, _g9, _g0, _text7, _text8, _text9, _text0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamsScope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 460",
    width: 1000,
    height: 460,
    role: "img",
    "aria-label": "BossDrop for Teams: a single team pod \\u2014 one team lead sets intent, one BossDrop AI coordination layer runs the cadence for about six team members, connected to chat, tasks and calendar. One team, one roster, one cadence.",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "tsAmbient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.36,
    fy: 0.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7161b2",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5d5094",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4c4380",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#453c74",
    stopOpacity: 0.038
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3f3769",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3769",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tsBandGlow",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7a4e6",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#b7a4e6",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#8f7fd0",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8f7fd0",
    stopOpacity: 0.013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tsKey",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.33,
    fy: 0.38
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe9fa",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#cfc3ee",
    stopOpacity: 0.045
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#cfc3ee",
    stopOpacity: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfc3ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tsPoolHalo",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.4,
    fy: 0.36
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2b1ec",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9d8fd6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8f7fd0",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tsPoolFade",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.41,
    fy: 0.42
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fff",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tsPoolPlane",
    x1: 0.16,
    y1: 0.04,
    x2: 0.84,
    y2: 0.96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe9fa",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#c2b1ec",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9d8fd6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#4c4380",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1533",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "tsPoolMask"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "tspoolmask",
    cx: 500,
    cy: 298,
    rx: 380,
    ry: 74,
    fill: "url(#tsPoolFade)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tsRim",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfc3ee",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f2edfd",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#cfc3ee",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9d8fd6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d8fd6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tsTagHalo",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.42,
    fy: 0.38
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7a4e6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8f7fd0",
    stopOpacity: 0.085
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8f7fd0",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tsCast",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a0718",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0a0718",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0a0718",
    stopOpacity: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0718",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tsRowShadow",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07050f",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#07050f",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#07050f",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#07050f",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07050f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tsContact",
    cx: 0.42,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07050f",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#07050f",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#07050f",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07050f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tsai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b7a4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tsLine",
    gradientUnits: "userSpaceOnUse",
    x1: 215,
    y1: 230,
    x2: 785,
    y2: 230
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b7a4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tsaiShade",
    x1: 0.02,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ffffff",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1a1430",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1430",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tsTopHi",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffffff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tsTopHiSoft",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6ddfa",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e6ddfa",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6ddfa",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tsgold",
    cx: 0.34,
    cy: 0.28,
    r: 0.82
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffdf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff2bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#e9c46a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c39a3c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tsChipFace",
    x1: 0.1,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#474070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2e294c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201c38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tsChipEdge",
    x1: 0.1,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8477c9",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4c4380",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2547",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tsNodeFace",
    cx: 0.33,
    cy: 0.26,
    r: 0.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b61a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#3e3768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1a33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tsNodeEdge",
    x1: 0.15,
    y1: 0,
    x2: 0.7,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a294e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#665a9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3360"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tsLiftXLm",
    x: "-25%",
    y: "-250%",
    width: "150%",
    height: "600%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 2,
    floodColor: "#08061a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 4,
    dy: 10,
    stdDeviation: 9,
    floodColor: "#08061a",
    floodOpacity: 0.44
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 6,
    dy: 15,
    stdDeviation: 12,
    floodColor: "#08061a",
    floodOpacity: 0.32
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tsLiftXL",
    x: "-25%",
    y: "-250%",
    width: "150%",
    height: "600%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 2,
    floodColor: "#08061a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 6,
    dy: 15,
    stdDeviation: 13,
    floodColor: "#08061a",
    floodOpacity: 0.44
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 15,
    dy: 36,
    stdDeviation: 34,
    floodColor: "#08061a",
    floodOpacity: 0.32
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tsLiftM",
    x: "-70%",
    y: "-250%",
    width: "240%",
    height: "600%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 1.6,
    floodColor: "#08061a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 4,
    dy: 9,
    stdDeviation: 8,
    floodColor: "#08061a",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 5,
    dy: 11,
    stdDeviation: 9,
    floodColor: "#08061a",
    floodOpacity: 0.24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tsLiftS",
    x: "-20%",
    y: "-90%",
    width: "140%",
    height: "280%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 1.4,
    floodColor: "#08061a",
    floodOpacity: 0.55
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 3,
    dy: 6,
    stdDeviation: 6,
    floodColor: "#08061a",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tsTextSh",
    x: "-10%",
    y: "-60%",
    width: "130%",
    height: "260%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 1.5,
    stdDeviation: 2.6,
    floodColor: "#0b0918",
    floodOpacity: 0.66
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tsLineGlow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 4,
    floodColor: "#b7a4e6",
    floodOpacity: 0.35
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tsRimBlur",
    x: "-20%",
    y: "-400%",
    width: "140%",
    height: "900%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  })), /*#__PURE__*/React.createElement("style", null, "\n      .tst  { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#f4f0fc; }\n      .tss  { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:600; fill:#cfc3ee; }\n      .tseye{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#cfc3ee; letter-spacing:4px; }\n      .tspill{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#121020; }\n      .tslab{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#e2d9f5; }\n      .tschip{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#efe9fa; }\n      /* caption type, not a surface: no face, no edge, no lift */\n      .tstag{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#cfc3ee; letter-spacing:2.4px; }\n      .mOnly { display:none; }\n\n      /* Phone. An image-referenced SVG evaluates media queries against its own\n         rendered width, so this fires only at the ~343px the phone layout gives\n         it, where the desktop type would land at 4-5px. Type is enlarged to\n         what the artboard can hold and the surfaces grow with it. Geometry\n         only - every label stays horizontal and says the same thing. The key\n         light stays consistent: the lit top edges are re-drawn at the mobile\n         geometry rather than switched off. */\n      @media (max-width: 560px) {\n        /* type first: nothing here goes below 32 units, which is 11.0px at the\n           343px the phone gives this figure */\n        .tseye { font-size:34px; letter-spacing:5px; transform:translateY(-12px); }\n        .tst   { font-size:36px; transform:translateY(-10px); }\n        .tslab { font-size:34px; transform:translateY(-6px); }\n        .tss   { font-size:34px; }\n        .tspillBig { font-size:38px; transform:translateY(-7px); }\n        .tspillSub { font-size:32px; transform:translateY(8px); }\n        .tstag    { font-size:32px; letter-spacing:2px; transform:translateY(-16px); }\n        .tstaghalo{ cx:775px; cy:30px; rx:205px; ry:26px; }\n\n        /* then the geometry the type needs. The whole scene moves up and the\n           band goes nearly full width so the cadence line has room; the pod's\n           pool, its far rim and the row of people move with it, so the light\n           and the grouping stay exactly as they read on desktop. */\n        .tsband { x:70px; y:180px; width:860px; height:86px; rx:43px; }\n        .tsbandlift { filter: url(#tsLiftXLm); }\n        .dOnly  { display:none; }\n        .mOnly  { display:inline; }\n        .tspoolhalo { cy:236px; ry:124px; }\n        .tspoolmask { cy:288px; ry:68px; }\n        .tspoolrect { y:220px; height:136px; }\n        .tsrim      { transform:translateY(18px); }\n        .tsbandcast { cx:520px; cy:292px; rx:340px; ry:30px; }\n        .tslead     { transform:translateY(-10px); }\n        .tsintent   { transform:translateY(-10px); }\n        .tsfan      { transform:translateY(-14px); }\n        .tsmembers  { transform:translateY(-14px); }\n\n        /* tool chips grow; their labels, their lit top edges and their dashed\n           feeds all follow them out */\n        .tschipbox { width:190px; height:38px; rx:19px; y:364px; }\n        .tschipbox.a { x:45px; }\n        .tschipbox.b { x:405px; }\n        .tschipbox.c { x:765px; }\n        .tschip { font-size:33px; transform:translateY(-9.5px); }\n        .tschip.a { transform:translate(-150px,-9.5px); }\n        .tschip.c { transform:translate(150px,-9.5px); }\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 250,
    rx: 494,
    ry: 206,
    fill: "url(#tsAmbient)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 230,
    rx: 358,
    ry: 112,
    fill: "url(#tsBandGlow)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 470,
    cy: 224,
    rx: 460,
    ry: 196,
    fill: "url(#tsKey)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "tspoolhalo",
    cx: 500,
    cy: 246,
    rx: 380,
    ry: 132,
    fill: "url(#tsPoolHalo)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tsPoolMask)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "tspoolrect",
    x: 120,
    y: 224,
    width: 760,
    height: 148,
    fill: "url(#tsPoolPlane)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tsrim",
    d: "M170 268 A330 40 0 0 0 830 268",
    fill: "none",
    stroke: "url(#tsRim)",
    strokeWidth: 3,
    strokeLinecap: "round",
    filter: "url(#tsRimBlur)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "tsbandcast",
    cx: 530,
    cy: 290,
    rx: 262,
    ry: 32,
    fill: "url(#tsCast)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 46,
    className: "tseye",
    fontSize: 15,
    filter: "url(#tsTextSh)"
  }, "TEAMS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 84,
    className: "tst",
    fontSize: 26,
    filter: "url(#tsTextSh)"
  }, "One team. One BossDrop layer.")), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "tstaghalo",
    cx: 880,
    cy: 44,
    rx: 110,
    ry: 34,
    fill: "url(#tsTagHalo)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 942,
    y: 50,
    textAnchor: "end",
    className: "tstag",
    fontSize: 13,
    filter: "url(#tsTextSh)"
  }, "SINGLE TEAM")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 114,
    textAnchor: "middle",
    className: "tslab",
    fontSize: 15,
    filter: "url(#tsTextSh)"
  }, "Team lead sets intent &amp; approves")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "tslead"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tsLiftS)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 148,
    r: 19,
    fill: "url(#tsgold)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2a1f08",
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 142,
    r: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 160 a10 8 0 0 1 20 0 z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M487.1 135.1 A18.24 18.24 0 0 1 512.9 135.1",
    fill: "none",
    stroke: "url(#tsTopHi)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "tsintent",
    stroke: "url(#tsLine)",
    strokeWidth: 2.5,
    opacity: 0.62,
    filter: "url(#tsLineGlow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 493,
    y1: 165,
    x2: 462,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 167,
    x2: 500,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 507,
    y1: 165,
    x2: 538,
    y2: 200
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "tsfan",
    stroke: "#8f7fd0",
    strokeWidth: 2,
    opacity: 0.66,
    filter: "url(#tsLineGlow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 250,
    x2: 245,
    y2: 301
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398,
    y1: 250,
    x2: 347,
    y2: 301
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466,
    y1: 250,
    x2: 449,
    y2: 301
  }), /*#__PURE__*/React.createElement("line", {
    x1: 534,
    y1: 250,
    x2: 551,
    y2: 301
  }), /*#__PURE__*/React.createElement("line", {
    x1: 602,
    y1: 250,
    x2: 653,
    y2: 301
  }), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 250,
    x2: 755,
    y2: 301
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "tsbandlift",
    filter: "url(#tsLiftXL)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "tsband",
    x: 250,
    y: 200,
    width: 500,
    height: 62,
    rx: 31,
    fill: "url(#tsai)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "tsband",
    x: 250,
    y: 200,
    width: 500,
    height: 62,
    rx: 31,
    fill: "url(#tsaiShade)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "dOnly",
    d: "M250.9 231 A30.1 30.1 0 0 1 281 200.9 L719 200.9 A30.1 30.1 0 0 1 749.1 231",
    fill: "none",
    stroke: "url(#tsTopHi)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "mOnly",
    d: "M70.9 223 A42.1 42.1 0 0 1 113 180.9 L887 180.9 A42.1 42.1 0 0 1 929.1 223",
    fill: "none",
    stroke: "url(#tsTopHi)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 223,
    textAnchor: "middle",
    className: "tspill tspillBig",
    fontSize: 21
  }, "BossDrop AI")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 246,
    textAnchor: "middle",
    className: "tspill tspillSub",
    fontSize: 13
  }, "one operating cadence \xB7 status \xB7 risks \xB7 brief")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "tsmembers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 506,
    cy: 350,
    rx: 300,
    ry: 26,
    fill: "url(#tsRowShadow)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 251,
    cy: 349,
    rx: 34,
    ry: 9,
    fill: "url(#tsContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 353,
    cy: 349,
    rx: 34,
    ry: 9,
    fill: "url(#tsContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 455,
    cy: 349,
    rx: 34,
    ry: 9,
    fill: "url(#tsContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 557,
    cy: 349,
    rx: 34,
    ry: 9,
    fill: "url(#tsContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 659,
    cy: 349,
    rx: 34,
    ry: 9,
    fill: "url(#tsContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 761,
    cy: 349,
    rx: 34,
    ry: 9,
    fill: "url(#tsContact)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#tsLiftS)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#tsNodeFace)",
    stroke: "url(#tsNodeEdge)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 320,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 320,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 320,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551,
    cy: 320,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 653,
    cy: 320,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 755,
    cy: 320,
    r: 19
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d7cdf2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 314,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 314,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 314,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551,
    cy: 314,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 653,
    cy: 314,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 755,
    cy: 314,
    r: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 336 a13 10 0 0 1 26 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 336 a13 10 0 0 1 26 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436 336 a13 10 0 0 1 26 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538 336 a13 10 0 0 1 26 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 336 a13 10 0 0 1 26 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742 336 a13 10 0 0 1 26 0 z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#tsTopHiSoft)",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.1 307.1 A18.24 18.24 0 0 1 257.9 307.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.1 307.1 A18.24 18.24 0 0 1 359.9 307.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.1 307.1 A18.24 18.24 0 0 1 461.9 307.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.1 307.1 A18.24 18.24 0 0 1 563.9 307.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.1 307.1 A18.24 18.24 0 0 1 665.9 307.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.1 307.1 A18.24 18.24 0 0 1 767.9 307.1"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#9384d4",
    strokeWidth: 1.8,
    strokeDasharray: "3 4",
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("g", {
    className: "dOnly"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 384,
    x2: 290,
    y2: 360
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 384,
    x2: 500,
    y2: 360
  }), /*#__PURE__*/React.createElement("line", {
    x1: 710,
    y1: 384,
    x2: 710,
    y2: 360
  })), /*#__PURE__*/React.createElement("g", {
    className: "mOnly"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 362,
    x2: 243,
    y2: 338
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 362,
    x2: 500,
    y2: 338
  }), /*#__PURE__*/React.createElement("line", {
    x1: 850,
    y1: 362,
    x2: 757,
    y2: 338
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tsLiftM)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "tschipbox a",
    x: 224,
    y: 384,
    width: 132,
    height: 30,
    rx: 15,
    fill: "url(#tsChipFace)",
    stroke: "url(#tsChipEdge)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "tschipbox b",
    x: 434,
    y: 384,
    width: 132,
    height: 30,
    rx: 15,
    fill: "url(#tsChipFace)",
    stroke: "url(#tsChipEdge)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "tschipbox c",
    x: 644,
    y: 384,
    width: 132,
    height: 30,
    rx: 15,
    fill: "url(#tsChipFace)",
    stroke: "url(#tsChipEdge)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "dOnly",
    fill: "none",
    stroke: "url(#tsTopHiSoft)",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.9 399 A14.1 14.1 0 0 1 239 384.9 L341 384.9 A14.1 14.1 0 0 1 355.1 399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.9 399 A14.1 14.1 0 0 1 449 384.9 L551 384.9 A14.1 14.1 0 0 1 565.1 399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.9 399 A14.1 14.1 0 0 1 659 384.9 L761 384.9 A14.1 14.1 0 0 1 775.1 399"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "mOnly",
    fill: "none",
    stroke: "url(#tsTopHiSoft)",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9 383 A18.1 18.1 0 0 1 64 364.9 L216 364.9 A18.1 18.1 0 0 1 234.1 383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.9 383 A18.1 18.1 0 0 1 424 364.9 L576 364.9 A18.1 18.1 0 0 1 594.1 383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.9 383 A18.1 18.1 0 0 1 784 364.9 L936 364.9 A18.1 18.1 0 0 1 954.1 383"
  }))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 403.5,
    textAnchor: "middle",
    className: "tschip a",
    fontSize: 13
  }, "Chat")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 403.5,
    textAnchor: "middle",
    className: "tschip b",
    fontSize: 13
  }, "Tasks")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 403.5,
    textAnchor: "middle",
    className: "tschip c",
    fontSize: 13
  }, "Calendar")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 446,
    textAnchor: "middle",
    className: "tss",
    fontSize: 14,
    filter: "url(#tsTextSh)"
  }, "One team \xB7 one roster \xB7 one cadence")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsScope);
export default __webpack_public_path__ + "static/media/teams-scope.e97d82110a780a8e2247bc93b10dd36d.svg";
export { ForwardRef as ReactComponent };